module.exports = __webpack_public_path__ + "img/header-theme-primary.d7024f7e.svg";